import { RoleContent } from '.'
// import { imgStories as imgs } from '../images'

export const roleStories: Record<string, RoleContent> = {
  introRole: {
    a: [
      [
        {
          text: `「我就知道，這趟旅程少不了某個笨蛋。」
李澤言的目光掃過你，語氣依舊帶著他一貫的冷靜，眼神深處卻隱約透著一絲……你，難以忽視的溫柔。`,
        },
      ],
      [
        {
          text: `「這次任務的關鍵在於樂園裡的星石碎片。我已經找到了一些線索，接下來就看某人的表現了。」
          他語氣果斷，讓你感受到安心。`,
        },
      ],
    ],
    b: [
      [
        {
          text: `「你還好嗎？這趟旅途應該沒有看起來那麼簡單。」
白起語氣裡帶著對你的關心，彷彿隨時準備著與你一起應對危險。`,
        },
      ],
      [
        {
          text: `「星石碎片的傳說並不是虛構的。我手裡現在有些線索，之後會需要你幫忙。」
白起的語氣認真與謹慎，像是在分享某個重要的祕密，同時也將他的信任交付於你。`,
        },
      ],
    ],
    c: [
      [
        {
          text: `「我早就猜到，某位同學會在這裡。」
許墨微笑著看著你，那雙深邃的眼睛像是能看透一切，讓你不禁想要靠近。`,
        },
      ],
      [
        {
          text: `「星石的碎片記錄著一段未曾解開的記憶。如果你願意，可以陪我一起揭開這段謎題嗎？」
許墨微笑著邀請，讓你不禁想與他一起去探索這段未知的冒險。`,
        },
      ],
    ],
    d: [
      [
        {
          text: `「果然是你，薯片小姐！這次的旅程一定會很有趣！」
周棋洛的雙眼閃爍著興奮與期待，彷彿看到你就讓他無比開心。`,
        },
      ],
      [
        {
          text: `「我剛好知道一些星石的線索，我們一起行動，一定會更快找到它！」
他的語氣輕快且興奮，就像是面對一場快樂的遊戲，讓你忍不住想跟隨他一探究竟。`,
        },
      ],
    ],
    e: [
      [
        {
          text: `「沒想到在這種地方，也能碰到你。」
凌肖微微挑眉，嘴角勾起一抹似笑非笑的弧度。然而，他的目光卻落在你身上，像是在尋找什麼，向你靠近了一步。`,
        },
      ],
      [
        {
          text: `「星石碎片的事，我也知道一點線索，要不要一起來做點有意思的事？」
雖然在邀請，凌肖的目光卻始終注視著你，似乎早已算準你會接受。`,
        },
      ],
    ],
  },

  stage1: {
    a: [
      [
        {
          text: `你們來到遊樂園的「巡弋飛椅」。
          這座設施有著七種不同的色彩，每個飛椅上標有數字，隨著微風輕輕搖曳，彷彿在低語著一段被塵封的往事。`,
        },
      ],
      [
        {
          text: `就在你們注視著這座飛椅時，一個神秘的寶箱突然出現在眼前，寶箱的表面鑲嵌著七個顏色各異的旋鈕。
          「看來這不是普通的遊樂設施，而是一個挑戰。」`,
        },
      ],
      [
        {
          text: `李澤言皺了皺眉，低頭看向寶箱上的旋鈕，語氣中透著冷靜。
「線索書寫著：『將七個箭頭旋鈕按順時針方向旋轉指定的格數，答案就會浮現。』給出的提示足夠明顯了。」`,
        },
      ],
      [
        {
          text: `李澤言指向寶箱上的旋鈕，語氣果斷而堅定。
「解開寶箱跟巡弋飛椅間的關聯，或許就能打開這個寶箱。」`,
        },
      ],
      [
        {
          text: `當你根據提示，將七個旋鈕按照指定的格數調整到正確的位置後，寶箱突然輕微震動了一下，隨後傳出一聲輕響。
          七個旋鈕同時發出柔和的光芒，寶箱的鎖緩緩打開。一道耀眼的金色光芒從寶箱內湧出，瞬間照亮了整個巡弋飛椅的周圍。`,
        },
      ],
      [
        {
          text: `「答案是奇蹟。」
李澤言伸手從寶箱中拿出一片閃耀著金光的星石碎片，目光落在你身上。
`,
        },
      ],
      [
        {
          text: `「無論未來有多少挑戰，相信我們也能創造屬於我們自己的奇蹟。」`,
        },
      ],
    ],
    b: [
      [
        {
          text: `你們來到遊樂園的「巡弋飛椅」。
          這座設施有著七種不同的色彩，每個飛椅上標有數字，隨著微風輕輕搖曳，彷彿在低語著一段被塵封的往事。`,
        },
      ],
      [
        {
          text: `就在你們注視著這座飛椅時，一個神秘的寶箱突然出現在眼前，寶箱的表面鑲嵌著七個顏色各異的旋鈕。
          「這個寶箱，應該和飛椅有關。」`,
        },
      ],
      [
        {
          text: `白起看向寶箱上的旋鈕，語氣中帶著一絲專注。
          「箭頭旋鈕需要順時針旋轉指定的格數才能解開，我們要先找到正確的規律。」`,
        },
      ],
      [
        {
          text: `白起目光鎖定寶箱，語氣低沉而堅定，像是在給你信心。
          「先把這個寶箱打開吧，看看裡面到底藏著什麼。」`,
        },
      ],
      [
        {
          text: `當你根據提示，將七個旋鈕按照指定的格數調整到正確的位置後，寶箱突然輕微震動了一下，隨後傳出一聲輕響。
          七個旋鈕同時發出柔和的光芒，寶箱的鎖緩緩打開。一道耀眼的金色光芒從寶箱內湧出，瞬間照亮了整個巡弋飛椅的周圍。`,
        },
      ],
      [
        {
          text: `「『奇蹟』……原來是這樣。」
          白起拿出寶箱中的星石碎片，指尖輕輕擦過它的表面。`,
        },
      ],
      [
        {
          text: `「這片星石見證了他們的故事。有你在，我們才能找得這麼順利。」`,
        },
      ],
    ],
    c: [
      [
        {
          text: `你們來到遊樂園的「巡弋飛椅」。
          這座設施有著七種不同的色彩，每個飛椅上標有數字，隨著微風輕輕搖曳，彷彿在低語著一段被塵封的往事。`,
        },
      ],
      [
        {
          text: `就在你們注視著這座飛椅時，一個神秘的寶箱突然出現在眼前，寶箱的表面鑲嵌著七個顏色各異的旋鈕。
          「這座飛椅裡，似乎隱藏了某些祕密。」`,
        },
      ],
      [
        {
          text: `許墨專注地注視著寶箱上的旋鈕，語氣帶著一絲探究的意味。
          「根據線索書的描述，這些箭頭旋鈕需要順時針旋轉到指定位置……這應該是與飛椅數字的規律有關。」`,
        },
      ],
      [
        {
          text: `許墨微微一笑，語氣溫和而充滿信心。
          「我們一起解開這個寶箱，看看裡面藏著什麼祕密吧。」`,
        },
      ],
      [
        {
          text: `當你根據提示，將七個旋鈕按照指定的格數調整到正確的位置後，寶箱突然輕微震動了一下，隨後傳出一聲輕響。
          七個旋鈕同時發出柔和的光芒，寶箱的鎖緩緩打開。一道耀眼的金色光芒從寶箱內湧出，瞬間照亮了整個巡弋飛椅的周圍。`,
        },
      ],
      [
        {
          text: `「『奇蹟』……真是一個耐人尋味的答案。」
          許墨輕輕拿出星石碎片，隨即轉向你，嘴角揚起溫柔的弧度。`,
        },
      ],
      [
        {
          text: `「這片星石見證了他們的奇蹟。我很期待，接下來與你一起探索更多的祕密。」`,
        },
      ],
    ],
    d: [
      [
        {
          text: `你們來到遊樂園的「巡弋飛椅」。
          這座設施有著七種不同的色彩，每個飛椅上標有數字，隨著微風輕輕搖曳，彷彿在低語著一段被塵封的往事。`,
        },
      ],
      [
        {
          text: `就在你們注視著這座飛椅時，一個神秘的寶箱突然出現在眼前，寶箱的表面鑲嵌著七個顏色各異的旋鈕。
          「這個寶箱看起來很特別……阿薯，你覺得這裡是不是藏著什麼驚喜？」`,
        },
      ],
      [
        {
          text: `周棋洛好奇地觀察著寶箱上的旋鈕，語氣卻透著一絲認真。
          「線索書上說『將七個箭頭旋鈕按順時針方向旋轉指定的格數，答案就會浮現。』」`,
        },
      ],
      [
        {
          text: `他抬起頭看向你，語氣輕快又鼓舞人心。
          「我們試試看吧！一定可以解開的！」`,
        },
      ],
      [
        {
          text: `當你根據提示，將七個旋鈕按照指定的格數調整到正確的位置後，寶箱突然輕微震動了一下，隨後傳出一聲輕響。
          七個旋鈕同時發出柔和的光芒，寶箱的鎖緩緩打開。一道耀眼的金色光芒從寶箱內湧出，瞬間照亮了整個巡弋飛椅的周圍。`,
        },
      ],
      [
        {
          text: `「『Miracle奇蹟』！好浪漫的答案啊！」
          周棋洛輕聲感嘆，從寶箱中取出閃耀的星石碎片，目光溫柔地看向你。`,
        },
      ],
      [
        {
          text: `「代表我們完成了一件了不起的事。接下來，我們也要一起創造更多奇蹟！」`,
        },
      ],
    ],
    e: [
      [
        {
          text: `你們來到遊樂園的「巡弋飛椅」。
          這座設施有著七種不同的色彩，每個飛椅上標有數字，隨著微風輕輕搖曳，彷彿在低語著一段被塵封的往事。`,
        },
      ],
      [
        {
          text: `就在你們注視著這座飛椅時，一個神秘的寶箱突然出現在眼前，寶箱的表面鑲嵌著七個顏色各異的旋鈕。
          「這種詭異的設施肯定有問題。這個寶箱，十之八九和那些飛椅有關。」`,
        },
      ],
      [
        {
          text: `凌肖皺了皺眉，仔細地觀察寶箱上的旋鈕。
          「線索書說：『將七個箭頭旋鈕按順時針方向旋轉指定的格數，答案就會浮現。』看起來不難，跟上節奏就好。」`,
        },
      ],
      [
        {
          text: `他低頭檢查旋鈕，嘴角微微上揚。
          「怎麼樣，這難不倒你吧？」`,
        },
      ],
      [
        {
          text: `當你根據提示，將七個旋鈕按照指定的格數調整到正確的位置後，寶箱突然輕微震動了一下，隨後傳出一聲輕響。
          七個旋鈕同時發出柔和的光芒，寶箱的鎖緩緩打開。一道耀眼的金色光芒從寶箱內湧出，瞬間照亮了整個巡弋飛椅的周圍。`,
        },
      ],
      [
        {
          text: `『Miracle奇蹟』……總算解開了。
          凌肖輕聲嘀咕，從寶箱中拿出星石碎片。`,
        },
      ],
      [
        {
          text: `「你剛剛的表現，倒是滿讓人刮目相看的。」
          凌肖轉頭看向你，語氣中透著難得的認真。
          「接下來還有更多挑戰，還算有意思。畢竟，我很享受和你一起並肩作戰。」`,
        },
      ],
    ],
  },
  stage2: {
    a: [
      [
        {
          text: `在尋找星石的旅途中，你們來到了一座神秘的太空基地。據說，星石見證的那對情侶曾在這裡談過一場跨越星河的愛戀。`,
        },
      ],
      [
        {
          text: `然而，他們的重逢被黑魔法師阻撓。前方的空氣中忽然湧動起一股詭異的能量，彷彿整個世界都靜止了一般，隨即出現了一道閃爍著詭異光芒的結界。`,
        },
      ],
      [
        {
          text: `飄浮的文字與物品阻擋在結界兩側，那對情侶只能彼此遙望，無法相見。
          「……是黑魔法師的把戲。」`,
        },
      ],
      [
        {
          text: `李澤言轉身指向五個太空人，語氣低沉且果斷。
          「根據線索書記載，要讓他們突破阻隔，要先解開結界密語。」`,
        },
      ],
      [
        {
          text: `「這些太空人應該是解開密語的關鍵。先按照他們的特徵，由左到右連線吧。」`,
        },
      ],
      [
        {
          text: `當你輸入「等待」後，星石碎片閃耀了光芒，兩人中間的結界漸漸消散。
          「破除結界的關鍵，原來是『等待』。」他的語氣稍稍放緩，低頭看著你。`,
        },
      ],
      [
        {
          text: `「這片星石碎片到手還算順利。不過接下來的情況，也別鬆懈。」`,
        },
      ],
    ],
    b: [
      [
        {
          text: `在尋找星石的旅途中，你們來到了一座神秘的太空基地。據說，星石見證的那對情侶曾在這裡談過一場跨越星河的愛戀。`,
        },
      ],
      [
        {
          text: `然而，他們的重逢被黑魔法師阻撓。前方的空氣中忽然湧動起一股詭異的能量，彷彿整個世界都靜止了一般，隨即出現了一道閃爍著詭異光芒的結界。`,
        },
      ],
      [
        {
          text: `飄浮的文字與物品阻擋在結界兩側，那對情侶只能彼此遙望，無法相見。
          「黑魔法師……果然又是他的陰謀。」`,
        },
      ],
      [
        {
          text: `白起的眉頭微微皺起，目光落在結界上。
          「看來如果不阻止這詛咒，他們就永遠無法重逢。」`,
        },
      ],
      [
        {
          text: `「解開結界的關鍵應該在這些太空人上。按照特徵由左到右連線，密語應該就會浮現。」`,
        },
      ],
      [
        {
          text: `當你輸入「等待」後，星石碎片閃耀了光芒，兩人中間的結界漸漸消散。
          「是『等待』。看來那對情侶的愛，歷經了漫長的考驗。」`,
        },
      ],
      [
        {
          text: `白起望向結界消散的光芒，眼神中透著些許欣慰。
          「結界消散，這片星石碎片也成功找回了。不過接下來的任務，還需要你和我一起。」`,
        },
      ],
    ],
    c: [
      [
        {
          text: `在尋找星石的旅途中，你們來到了一座神秘的太空基地。據說，星石見證的那對情侶曾在這裡談過一場跨越星河的愛戀。`,
        },
      ],
      [
        {
          text: `然而，他們的重逢被黑魔法師阻撓。前方的空氣中忽然湧動起一股詭異的能量，彷彿整個世界都靜止了一般，隨即出現了一道閃爍著詭異光芒的結界。`,
        },
      ],
      [
        {
          text: `飄浮的文字與物品阻擋在結界兩側，那對情侶只能彼此遙望，無法相見。
          「看來，黑魔法師真的很仇視這段愛戀。」`,
        },
      ],
      [
        {
          text: `許墨翻開線索書，似乎找到了破局的方法。
          「根據記載，這裡的太空人隱藏著解開結界的密語。」`,
        },
      ],
      [
        {
          text: `「按照太空人的特徵由左到右連線，就能解開這段祕密。相信真相，已經在等我們揭曉了。」`,
        },
      ],
      [
        {
          text: `當你輸入「等待」後，星石碎片閃耀了光芒，兩人中間的結界漸漸消散。
          「『等待』……看來這對情侶的故事，正是通過這份堅定讓星石的力量得以重現。」`,
        },
      ],
      [
        {
          text: `許墨低聲笑了笑，然後注視著你。
          「這段等待的故事，讓人不禁感嘆時間的奇妙……接下來，我們繼續完成剩下的任務吧。」`,
        },
      ],
    ],
    d: [
      [
        {
          text: `在尋找星石的旅途中，你們來到了一座神秘的太空基地。據說，星石見證的那對情侶曾在這裡談過一場跨越星河的愛戀。`,
        },
      ],
      [
        {
          text: `然而，他們的重逢被黑魔法師阻撓。前方的空氣中忽然湧動起一股詭異的能量，彷彿整個世界都靜止了一般，隨即出現了一道閃爍著詭異光芒的結界。`,
        },
      ],
      [
        {
          text: `飄浮的文字與物品阻擋在結界兩側，那對情侶只能彼此遙望，無法相見。
          「這道結界看起來很牢固……應該是黑魔法師的手筆。」`,
        },
      ],
      [
        {
          text: `周棋洛挽起袖子，眼神中透出一絲堅定。他看向結界，語氣躍躍欲試。
          「這裡有五個太空人，一定是解謎的關鍵！」`,
        },
      ],
      [
        {
          text: `「按照太空人的特徵由左到右連線……薯片小姐，先這樣試試看吧！」`,
        },
      ],
      [
        {
          text: `當你輸入「等待」後，星石碎片閃耀了光芒，兩人中間的結界漸漸消散。
          「原來答案是『等待』！」`,
        },
      ],
      [
        {
          text: `周棋洛笑著看向你，然後調皮地突然靠近。
          「這對情侶的故事真的很浪漫……看來即使時間，也無法阻擋真誠的心意！」`,
        },
      ],
    ],
    e: [
      [
        {
          text: `在尋找星石的旅途中，你們來到了一座神秘的太空基地。據說，星石見證的那對情侶曾在這裡談過一場跨越星河的愛戀。`,
        },
      ],
      [
        {
          text: `然而，他們的重逢被黑魔法師阻撓。前方的空氣中忽然湧動起一股詭異的能量，彷彿整個世界都靜止了一般，隨即出現了一道閃爍著詭異光芒的結界。`,
        },
      ],
      [
        {
          text: `飄浮的文字與物品阻擋在結界兩側，那對情侶只能彼此遙望，無法相見。
          「……又是這個黑魔法師的詭計。」`,
        },
      ],
      [
        {
          text: `凌肖上前仔細觀察結界，嘴角微微上揚。
          「看起來，這五個太空人應該是解開結界的關鍵。」`,
        },
      ],
      [
        {
          text: `「按照他們的特徵由左到右連線，密語就會浮現了。別浪費時間，一起解開它吧。」`,
        },
      ],
      [
        {
          text: `當你輸入「等待」後，星石碎片閃耀了光芒，兩人中間的結界漸漸消散。
          「『等待』大概是他們唯一的選擇。不過他們的故事，也因為這份等待而有了意義。」`,
        },
      ],
      [
        {
          text: `凌肖微微挑眉，語氣中帶著一絲淡淡的調侃，但目光中卻透著認真。
          「擔心這些幹嘛，反正我會一直陪著你，不管你去哪裡。」`,
        },
      ],
    ],
  },
  stage3: {
    a: [
      [
        {
          text: `尋找星石的旅程中，你們偶然得知黑魔法師偷走了那對情侶的某樣寶物，並且利用了魔法封印了它。
          「這些幾何圖案，應該就是黑魔法師設置的陷阱。」`,
        },
      ],
      [
        {
          text: `李澤言冷靜地掃視著圖案，語氣低沉而果斷。
          「根據線索書的提示，這些圖案分別對應1到6的數字。」`,
        },
      ],
      [
        {
          text: `李澤言拿出線索書翻到指定頁，遞到你的面前。
          「這六個算式是解開封印的關鍵。將它們的結果轉換成英文字母，就會浮現密語。」`,
        },
      ],
      [
        {
          text: `當你輸入「回憶」後，星石碎片猛然閃耀。原來，黑魔法師偷走的是那對情侶珍貴的回憶。隨著光芒四散，星石深藏的記憶被喚醒，一幅動人的畫面浮現在你們面前。`,
        },
      ],
      [
        {
          text: `李澤言專注地注視著星石的光芒：「雖然記憶被封印，好在依然完整地保存下來。」
          李澤言的目光轉向你，語氣緩和，帶著一絲不易察覺的柔情。`,
        },
      ],
      [
        {
          text: `「我們的努力沒有白費。星石的力量已經回歸，繼續接下來的任務吧。」`,
        },
      ],
    ],
    b: [
      [
        {
          text: `尋找星石的旅程中，你們偶然得知黑魔法師偷走了那對情侶的某樣寶物，並且利用魔法封印了它。
          「這些幾何圖案裡好像藏著線索。」`,
        },
      ],
      [
        {
          text: `白起的眉頭微微皺起，眼中透著思索。
          「線索書說它們代表1到6，很可能和現場的圖案數量有關。」`,
        },
      ],
      [
        {
          text: `白起翻到關鍵頁，點了點上面的算式。
          「將這六個算式的結果轉換成字母，應該就能破解密語。我們試試看吧。」`,
        },
      ],
      [
        {
          text: `當你輸入「回憶」後，星石碎片猛然閃耀。原來，黑魔法師偷走的是那對情侶珍貴的回憶。隨著光芒四散，星石深藏的記憶被喚醒，一幅動人的畫面浮現在你們面前。`,
        },
      ],
      [
        {
          text: `「即使被黑魔法師試圖抹去，他們的記憶依然被星石完整地守護著。」
          白起轉向你，眼神中有著深深的堅定。`,
        },
      ],
      [
        {
          text: `「星石的力量終於回來了。休息一下，我們再繼續完成剩下的挑戰。」`,
        },
      ],
    ],
    c: [
      [
        {
          text: `尋找星石的旅程中，你們偶然得知黑魔法師偷走了那對情侶的某樣寶物，並且用魔法封印了它。
          「這些幾何圖案似乎不只是隨機排列。」`,
        },
      ],
      [
        {
          text: `許墨語氣柔和，透著一絲深思。
          「根據線索書，這些圖案分別對應1到6的數字，圖案數量大概就是解謎的關鍵。」`,
        },
      ],
      [
        {
          text: `許墨從容地翻開線索書，手指滑過算式頁，向你展示其中的邏輯。
          「這六個算式就是破解密語的密鑰。把數字轉換為字母，密語就會揭示出來。接下來，我們可以一起試著解開它。」`,
        },
      ],
      [
        {
          text: `當你輸入「回憶」後，星石碎片猛然閃耀。原來，黑魔法師偷走的是那對情侶珍貴的回憶。隨著光芒四散，星石深藏的記憶被喚醒，一幅動人的畫面浮現在你們面前。`,
        },
      ],
      [
        {
          text: `「這些回憶即使被封印，依然完整無缺地保存了下來。」
          許墨微微側過頭，眼神專注地看向你，聲音更顯柔和。`,
        },
      ],
      [
        {
          text: `「看來星石的力量並未消散。接下來的挑戰，還需要我跟製作人繼續合力完成。」`,
        },
      ],
    ],
    d: [
      [
        {
          text: `尋找星石的旅程中，你們偶然得知黑魔法師偷走了那對情侶的某樣寶物，並且利用圖案魔法封印了它。
          「這些幾何圖案好像並不簡單。」`,
        },
      ],
      [
        {
          text: `周棋洛睜大了眼睛，語氣輕快而興奮。
          「線索書說它們分別代表1到6的數字，這應該跟現場圖案有關吧？」`,
        },
      ],
      [
        {
          text: `周棋洛迅速翻開線索書，眼神中閃爍著期待的光芒。
          「快看，只要根據算式把數字轉換成字母，我們就能破解咒語啦！」`,
        },
      ],
      [
        {
          text: `當你輸入「回憶」後，星石碎片猛然閃耀。原來，黑魔法師偷走的是那對情侶珍貴的回憶。隨著光芒四散，星石深藏的記憶被喚醒，一幅動人的畫面浮現在你們面前。`,
        },
      ],
      [
        {
          text: `「這就是他們的回憶吧？雖然被封印，好在那些重要的瞬間還是被完整地留了下來。」
          周棋洛轉過頭看向你，嘴角揚起燦爛的笑容。`,
        },
      ],
      [
        {
          text: `「其實對我來說，和你一起的每一刻，也都會成為最珍貴的記憶。」`,
        },
      ],
    ],
    e: [
      [
        {
          text: `尋找星石的旅程中，你們偶然得知黑魔法師偷走了那對情侶的某樣寶物，並且利用魔法封印了它。
          「黑魔法師果然花了不少心思在這上面，不過這點小把戲攔不住我們。」`,
        },
      ],
      [
        {
          text: `凌肖語氣中透著一絲漫不經心，但眼神卻專注地鎖定前方。
          「根據線索書，這些圖案對應1到6的數字，應該跟現場圖案有些關係。」`,
        },
      ],
      [
        {
          text: `凌肖打開線索書，用手指敲了敲六行算式的頁面。
          「這些算式就是咒語的線索，把數字轉換成字母，答案自然會出來。」`,
        },
      ],
      [
        {
          text: `當你輸入「回憶」後，星石碎片猛然閃耀。原來，黑魔法師偷走的是那對情侶珍貴的回憶。隨著光芒四散，星石深藏的記憶被喚醒，一幅動人的畫面浮現在你們面前。`,
        },
      ],
      [
        {
          text: `「這就是他們的回憶吧。即使被封印，還是被星石保存了下來。」
          凌肖將目光從星石轉向你，嘴角帶著一絲若有似無的笑意。`,
        },
      ],
      [
        {
          text: `「黑魔法師藏得很深，不過我們還是能解開他的把戲。」`,
        },
      ],
    ],
  },
  stage4: {
    a: [
      [
        {
          text: `在尋找星石的旅途中，你們登上了一艘被黑魔法詛咒的海盜船。據傳，這艘船曾是那對情侶最後一次相約之地。`,
        },
      ],
      [
        {
          text: `「那對情侶就是在這裡許下了誓言，被黑魔法師的詛咒封印。」
你順著李澤言的指引看去，發現仙人掌上有三種顏色格外鮮明。`,
        },
      ],
      [
        {
          text: `「先找到三棵正確顏色的仙人掌，才能清除黑魔法師的『冷漠』詛咒，還原誓言。」`,
        },
      ],
      [
        {
          text: `當你輸入「守護」後，仙人掌上的詛咒符號瞬間消散，化作點點星光融入星石之中。星石開始微微顫動，彷彿正在釋放它深藏的力量。`,
        },
      ],
      [
        {
          text: `「守護……這的確是重要的東西。」
          他的語氣低沉而果斷，目光專注地注視著星石的光芒。
          李澤言轉過頭，語氣雖然平靜，卻透著一絲柔情。`,
        },
      ],
      [
        {
          text: `「這次任務完成得不錯。接下來，繼續努力挖掘星石的其他力量吧。」`,
        },
      ],
    ],
    b: [
      [
        {
          text: `在尋找星石的旅途中，你們登上了一艘被黑魔法詛咒的海盜船。據傳，這艘船曾是那對情侶最後一次相約之地。`,
        },
      ],
      [
        {
          text: `「線索書記載，那對情侶的誓言被黑魔法師封印在那邊的仙人掌裡。」
右側的仙人掌果然有點不同尋常，其中三種顏色格外鮮亮，像是在等待被發現。`,
        },
      ],
      [
        {
          text: `「看來找到那三棵正確顏色的仙人掌後，就能清除黑魔法師留下的『冷漠』詛咒。」`,
        },
      ],
      [
        {
          text: `當你輸入「守護」後，仙人掌上的詛咒符號瞬間消散，化作點點星光融入星石之中。星石開始微微顫動，彷彿正在釋放它深藏的力量。`,
        },
      ],
      [
        {
          text: `「守護……這就是他們跨越所有阻礙的理由。」
          他轉向你，目光溫柔卻堅毅。`,
        },
      ],
      [
        {
          text: `「我們又成功解決了一個難題。之後還有其他挑戰，準備好了嗎？」`,
        },
      ],
    ],
    c: [
      [
        {
          text: `在尋找星石的旅途中，你們登上了一艘被黑魔法詛咒的海盜船。據傳，這艘船曾是那對情侶最後一次相約之地。`,
        },
      ],
      [
        {
          text: `「線索書記載，那對情侶的誓言被黑魔法師封印在這些仙人掌之中。詛咒的力量，隔絕了他們最重要的羈絆。」
          許墨的目光落在右側幾棵仙人掌上，三種顏色在黑暗的環境中顯得尤為明顯。`,
        },
      ],
      [
        {
          text: `「我們需要找到正確三種顏色的仙人掌，去除黑魔法師的『冷漠』詛咒。以你的洞察力，相信你可以做到。」`,
        },
      ],
      [
        {
          text: `當你輸入「守護」後，仙人掌上的詛咒符號瞬間消散，化作點點星光融入星石之中。星石開始微微顫動，彷彿正在釋放它深藏的力量。`,
        },
      ],
      [
        {
          text: `「守護……這力量的本質，來自真心的承諾。」
          許墨微微一笑，緩緩轉向你，語氣中帶著一絲溫柔的深情。`,
        },
      ],
      [
        {
          text: `「守護的力量，讓星石重獲新生。我很期待，接下來會與你遇到什麼驚喜。」`,
        },
      ],
    ],
    d: [
      [
        {
          text: `在尋找星石的旅途中，你們登上了一艘被黑魔法詛咒的海盜船。據傳，這艘船曾是那對情侶最後一次相約之地。`,
        },
      ],
      [
        {
          text: `「那邊的仙人掌好像有點奇特……線索書上寫，那對情侶的誓言就被封印在裡面！」
          你順著周棋洛的指引看去，發現右側的幾棵仙人掌格外醒目，三種顏色在其中熠熠生輝。`,
        },
      ],
      [
        {
          text: `「只要找到那三種正確顏色的仙人掌，再把『冷漠』詛咒打破，誓言就能重新回來啦！」`,
        },
      ],
      [
        {
          text: `當你輸入「守護」後，仙人掌上的詛咒符號瞬間消散，化作點點星光融入星石之中。星石開始微微顫動，彷彿正在釋放它深藏的力量。`,
        },
      ],
      [
        {
          text: `「成功了！守護的力量讓星石變得這麼耀眼，這一定是他們最想傳遞的心意！」
          周棋洛轉向你，笑容燦爛而真誠，語氣中帶著一絲難得的認真。`,
        },
      ],
      [
        {
          text: `「這次的任務又完成啦！我們繼續加油，還有更多冒險在等著我們呢！」`,
        },
      ],
    ],
    e: [
      [
        {
          text: `在尋找星石的旅途中，你們登上了一艘被黑魔法詛咒的海盜船。據傳，這艘船曾是那對情侶最後一次相約之地。`,
        },
      ],
      [
        {
          text: `「那邊的仙人掌明顯不對勁。那對情侶的誓言，恐怕就封印在那裡。」
          凌肖的目光緊緊盯著右側的幾棵仙人掌，三種顏色在陰影中閃爍，顯得異常鮮明。`,
        },
      ],
      [
        {
          text: `「我們要先找到正確的三棵仙人掌，然後刪除那些詛咒符號。這種小伎倆，對你來說應該不算難吧？」`,
        },
      ],
      [
        {
          text: `當你輸入「守護」後，仙人掌上的詛咒符號瞬間消散，化作點點星光融入星石之中。星石開始微微顫動，彷彿正在釋放它深藏的力量。`,
        },
      ],
      [
        {
          text: `「……沒想到是守護的力量。」
          凌肖偏過頭看向你，聲音裡多了幾分輕快。`,
        },
      ],
      [
        {
          text: `「星石已經找回來了，一起解決剩下的麻煩吧。」`,
        },
      ],
    ],
  },
  stage5: {
    a: [
      [
        {
          text: `在尋找星石的旅途中，你們潛入了一片神祕的水下世界。據說，這裡曾見證那對情侶之間的特殊羈絆。如今，卻被黑魔法師封印在海底的生物之間。`,
        },
      ],
      [
        {
          text: `「……那些海洋生物排列得有些奇怪。」
          在水流的輕輕拍打下，幾種海洋生物在你面前排列成隊，彷彿在等待你去發現牠們的祕密。`,
        },
      ],
      [
        {
          text: `「先找到小丑魚後面和海星前方的生物，再根據牠們周圍的符號拼湊出答案吧。」`,
        },
      ],
      [
        {
          text: `當你根據提示將符號拼湊在一起後，海底世界突然迸發出一道耀眼的光芒。逐漸排列成一個清晰的文字「承諾」。`,
        },
      ],
      [
        {
          text: `「『承諾』，這就是星石所守護的力量。」
          他目光定定地落在你身上，語氣冷靜中透著一絲柔情。`,
        },
      ],
      [
        {
          text: `「相信接下來的碎片，也能順利找回。」`,
        },
      ],
    ],
    b: [
      [
        {
          text: `在尋找星石的旅途中，你們潛入了一片神祕的水下世界。據說，這裡曾見證那對情侶之間的特殊羈絆。如今，卻被黑魔法師封印在海底的生物之間。`,
        },
      ],
      [
        {
          text: `「那些海洋生物的排列不太對勁。」
          在水流的輕輕拍打下，幾種海洋生物在你面前排列成隊，彷彿在等待你去發現它們的秘密。`,
        },
      ],
      [
        {
          text: `「根據線索，我們需要找到小丑魚後面和海星前方的生物，再把牠們周圍的符號拼湊起來。」`,
        },
      ],
      [
        {
          text: `當你根據提示將符號拼湊在一起後，海底世界突然迸發出一道耀眼的光芒。逐漸排列成一個清晰的文字「承諾」。`,
        },
      ],
      [
        {
          text: `「承諾，大概就是他們能跨越一切阻礙的理由。」
          白起轉過頭看著你，語氣柔和卻充滿力量。`,
        },
      ],
      [
        {
          text: `「接下來的挑戰，我也會一直陪著你，直到完成最後的任務。」`,
        },
      ],
    ],
    c: [
      [
        {
          text: `在尋找星石的旅途中，你們潛入了一片神祕的水下世界。據說，這裡曾見證那對情侶之間的特殊羈絆。如今，卻被黑魔法師封印在海底的生物之間。`,
        },
      ],
      [
        {
          text: `「這些生物的排列，像是在傳遞某種訊息。」
          在水流的輕輕拍打下，幾種海洋生物在你面前排列成隊，彷彿在等待你去發現牠們的祕密。`,
        },
      ],
      [
        {
          text: `「根據線索，找到小丑魚後面和海星前方的生物，然後把牠們周圍的符號拼湊起來，答案就會浮現。」`,
        },
      ],
      [
        {
          text: `當你根據提示將符號拼湊在一起後，海底世界突然迸發出一道耀眼的光芒。逐漸排列成一個清晰的文字「承諾」。`,
        },
      ],
      [
        {
          text: `「承諾是他們羈絆的象徵……也是星石守護的力量來源。」
          許墨的目光帶著一絲溫柔，輕輕轉向你。`,
        },
      ],
      [
        {
          text: `「星石的祕密或許還隱藏著更大的可能性，我們繼續深入探索吧。」`,
        },
      ],
    ],
    d: [
      [
        {
          text: `在尋找星石的旅途中，你們潛入了一片神祕的水下世界。據說，這裡曾見證那對情侶之間的特殊羈絆。如今，卻被黑魔法師封印在海底的生物之間。`,
        },
      ],
      [
        {
          text: `「這些海洋生物排得好整齊……難道這裡也藏著什麼祕密嗎？」
          在水流的輕輕拍打下，幾種海洋生物在你面前排列成隊，彷彿在等待你去發現牠們的祕密。`,
        },
      ],
      [
        {
          text: `「根據線索，小丑魚後面和海星前方的生物好像藏著我們要找的答案！先把牠們周圍的符號組合起來吧。」`,
        },
      ],
      [
        {
          text: `當你根據提示將符號拼湊在一起後，海底世界突然迸發出一道耀眼的光芒。逐漸排列成一個清晰的文字「承諾」。`,
        },
      ],
      [
        {
          text: `「原來是『承諾』……這就是他們的羈絆力量吧！
          周棋洛轉向你，笑容燦爛，眼神中滿是暖意。`,
        },
      ],
      [
        {
          text: `「每次和你一起解謎都超級有趣～接下來我們也一起加油吧，薯片小姐！」`,
        },
      ],
    ],
    e: [
      [
        {
          text: `在尋找星石的旅途中，你們潛入了一片神祕的水下世界。據說，這裡曾見證那對情侶之間的特殊羈絆。如今，卻被黑魔法師封印在海底的生物之間。`,
        },
      ],
      [
        {
          text: `「這些生物看起來不簡單，八成又是黑魔法師的把戲。」
          在水流的輕輕拍打下，幾種海洋生物在你面前排列成隊，彷彿在等待你去發現牠們的祕密。`,
        },
      ],
      [
        {
          text: `「小丑魚後面和海星前方的生物是關鍵，把牠們周圍的符號組合起來就行了。」`,
        },
      ],
      [
        {
          text: `當你根據提示將符號拼湊在一起後，海底世界突然迸發出一道耀眼的光芒。逐漸排列成一個清晰的文字「承諾」。`,
        },
      ],
      [
        {
          text: `「『承諾』……那對情侶的羈絆，看來比我想的更深。」
          凌肖瞥了你一眼，嘴角帶著一抹不易察覺的笑意。`,
        },
      ],
      [
        {
          text: `「還真有你的。接下來的挑戰，我就繼續期待了。」`,
        },
      ],
    ],
  },
  stage6: {
    a: [
      [
        {
          text: `在尋找星石的旅途中，你們走到了一座色彩斑斕的摩天輪前。每個車廂都閃爍著微弱的光芒，彷彿隱藏著某些未解之謎。「根據線索書記載，這裡是可以解開那對情侶祕密的地方。但具體在哪，我們還要仔細尋找。」`,
        },
      ],
      [
        {
          text: `你們翻開線索書，看到上面提到：「那對情侶間有兩個承載了羈絆的數字。解開他們的祕密，就能發現封印的真相。」`,
        },
      ],
      [
        {
          text: `「重要的日子……可能指的是他們的『幾週年』以及『紀念日的日期』。我記得他們的週年紀念日，與我們同天。」`,
        },
      ],
      [
        {
          text: `「用這兩個數字找出摩天輪車廂的顏色，配對網頁上的氣球找到答案吧。」`,
        },
      ],
      [
        {
          text: `隨著「約定」兩字浮現，摩天輪突然散發出耀眼的光芒，黑魔法師的封印被徹底瓦解。光芒匯聚成一道光柱，直接射向星石碎片，將它重新凝聚成更完整的模樣。`,
        },
      ],
      [
        {
          text: `「約定……這就是他們的週年見證。」
李澤言抬起頭注視著摩天輪的光芒，語氣低沉中透著一絲感慨。`,
        },
      ],
      [
        {
          text: `「他們的故事就像這摩天輪一樣，隨著每一年的輪迴一圈又一圈地延續。」`,
        },
      ],
    ],
    b: [
      [
        {
          text: `在尋找星石的旅途中，你們走到了一座色彩斑斕的摩天輪前。每個車廂都閃爍著微弱的光芒，彷彿隱藏著某些未解之謎。
          「這些車廂應該和那對情侶的祕密有關，我們可以找找線索。」`,
        },
      ],
      [
        {
          text: `你們翻開線索書，看到上面提到：「那對情侶有兩個承載了羈絆的數字。解開他們的祕密，就能發現封印的真相。」`,
        },
      ],
      [
        {
          text: `「這應該是他們的週年紀念日。找到代表『幾週年』和『幾月幾號』的數字，就能解開這個謎題，我記得他們的週年紀念日，與我們同天。」`,
        },
      ],
      [
        {
          text: `「找到數字後根據摩天輪車廂的顏色配對網頁上的氣球，應該就能找到答案。」`,
        },
      ],
      [
        {
          text: `隨著「約定」兩字浮現，摩天輪突然散發出耀眼的光芒，黑魔法師的封印被徹底瓦解。光芒匯聚成一道光柱，直接射向星石碎片，將它重新凝聚成更完整的模樣。`,
        },
      ],
      [
        {
          text: `「他們一直守護的答案，原來是約定。」
          白起抬頭注視著摩天輪的光芒，目光中帶著一絲柔和。`,
        },
      ],
      [
        {
          text: `「他們的故事跨越了輪迴，而無論未來有多少挑戰，我也都會守護你。」`,
        },
      ],
    ],
    c: [
      [
        {
          text: `在尋找星石的旅途中，你們走到了一座色彩斑斕的摩天輪前。每個車廂都閃爍著微弱的光芒，彷彿隱藏著某些未解之謎。「這座摩天輪看起來像是隱藏了一些訊息。看來要解開它，才能發現那對情侶的祕密。」`,
        },
      ],
      [
        {
          text: `你們翻開線索書，看到其提到：「那對情侶有兩個承載了羈絆的數字。解開他們的祕密，就能發現封印的真相。」`,
        },
      ],
      [
        {
          text: `根據線索，他們的週年紀念日應該是關鍵。我們需要找出『幾週年』和『幾月幾號』這兩個數字，進一步探索真相，我記得他們的週年紀念日，與我們同天。」`,
        },
      ],
      [
        {
          text: `「找到這些數字後觀察摩天輪的顏色，然後配對網頁上的氣球。這樣應該能拼湊出他們的羈絆答案。」`,
        },
      ],
      [
        {
          text: `隨著「約定」兩字浮現，摩天輪突然散發出耀眼的光芒，黑魔法師的封印被徹底瓦解。光芒匯聚成一道光柱，直接射向星石碎片，將它重新凝聚成更完整的模樣。`,
        },
      ],
      [
        {
          text: `「約定是他們故事的見證，也是星石力量的一部分。」
          許墨的目光停留在摩天輪的光芒中，嘴角微微勾起，語氣溫柔而深情。`,
        },
      ],
      [
        {
          text: `「每一次輪迴都在訴說故事的延續，正如我們的約定。」`,
        },
      ],
    ],
    d: [
      [
        {
          text: `在尋找星石的旅途中，你們走到了一座色彩斑斕的摩天輪前。每個車廂都閃爍著微弱的光芒，彷彿隱藏著某些未解之謎。「這座摩天輪好漂亮！不過……它的樣子好像有些不對勁。」`,
        },
      ],
      [
        {
          text: `你們翻開線索書，看到其提到：「那對情侶有著承載了羈絆的兩個數字。解開他們的祕密，就能發現封印的真相。」`,
        },
      ],
      [
        {
          text: `「嗯……兩個數字？說不定和他們的週年紀念日有關！」
          他托著下巴，語氣略顯認真，「來試試找到『幾週年』和『幾月幾號』吧！我記得他們的週年紀念日，與我們同天。」`,
        },
      ],
      [
        {
          text: `「找到這兩個數字之後，就看一看摩天輪上相應車廂的顏色，再用網頁上的氣球拼湊答案！」`,
        },
      ],
      [
        {
          text: `隨著「約定」兩字浮現，摩天輪突然散發出耀眼的光芒，黑魔法師的封印被徹底瓦解。光芒匯聚成一道光柱，直接射向星石碎片，將它重新凝聚成更完整的模樣。`,
        },
      ],
      [
        {
          text: `「約定……他們的故事真很讓人感動。」
          周棋洛抬起頭注視著摩天輪的光芒，眼神中透著一絲柔情。`,
        },
      ],
      [
        {
          text: `「摩天輪繞了一圈又一圈，總是連在一起，似乎也是種特別的羈絆。」`,
        },
      ],
    ],
    e: [
      [
        {
          text: `在尋找星石的旅途中，你們走到了一座色彩斑斕的摩天輪前。每個車廂都閃爍著微弱的光芒，彷彿隱藏著某些未解之謎。「看來這摩天輪不只是裝飾，應該還藏著那對情侶的祕密。」`,
        },
      ],
      [
        {
          text: `你們翻開線索書，看到其提到：「那對情侶有著承載了羈絆的兩個數字。解開他們的祕密，就能發現封印的真相。」`,
        },
      ],
      [
        {
          text: `「兩個數字？找到他們紀念日裡的『幾週年』和『幾月幾號』，十之八九就能解開這道謎題了，我記得他們的週年紀念日，與我們同天。」`,
        },
      ],
      [
        {
          text: `「解出數字後，看清楚摩天輪車廂的顏色，然後配對網頁上的氣球。這些氣球應該能給我們答案。」`,
        },
      ],
      [
        {
          text: `隨著「約定」兩字浮現，摩天輪突然散發出耀眼的光芒，黑魔法師的封印被徹底瓦解。光芒匯聚成一道光柱，直接射向星石碎片，將它重新凝聚成更完整的模樣。`,
        },
      ],
      [
        {
          text: `「約定？原來這就是他們一直守護的東西……」
          凌肖低頭看了你一眼，嘴角勾起笑意。`,
        },
      ],
      [
        {
          text: `「有些人之間的羈絆跟這座摩天輪滿像的，繞得很深，也很長。」`,
        },
      ],
    ],
  },
  ending: {
    a: [
      [
        {
          text: `當星石的六片記憶碎片成功合一，瞬間散發出耀眼的光芒，照亮了夜空。整個樂園彷彿在回應這股力量，微微震動，星石的光芒穿透了時間的屏障，讓古老的記憶再次甦醒。`,
        },
      ],
      [
        {
          text: `「雖然一切都在預料之中，不過某個笨蛋的表現……比我預想中還要好。」
          他將星石輕輕放入你的手心，低聲補充道。`,
        },
      ],
      [
        {
          text: `「你讓我相信，選擇可以帶來不同的結果。」
          他的眼神溫柔又深沉，讓你的心跳不由得加速，彷彿被他內心深藏的情感所吸引。`,
        },
      ],
      [
        {
          text: `「這段旅程中，某人做得很好。」
          他微微停頓，低下頭親吻了你一下。`,
        },
      ],
      [
        {
          text: `「這顆星石能重生，少不了某人的努力。之後未來的挑戰，我也都會與你一起見證。」`,
        },
      ],
    ],
    b: [
      [
        {
          text: `當星石的六片記憶碎片成功合一，瞬間散發出耀眼的光芒，照亮了夜空。整個樂園彷彿在回應這股力量，微微震動，星石的光芒穿透了時間的屏障，讓古老的記憶再次甦醒。`,
        },
      ],
      [
        {
          text: `「成功了……我們堅持到了最後。」
          他微微一笑，望著你手中的星石，聲音低柔而真摯。`,
        },
      ],
      [
        {
          text: `「這顆星石，見證了我們的一切。」
          他的聲音漸漸放低，靠近你的耳畔。`,
        },
      ],
      [
        {
          text: `「不論再艱難的旅程，我都會陪你走下去。」
          白起輕輕摸了摸自己的後頸，露出一抹笑容。`,
        },
      ],
      [
        {
          text: `「這顆星石的意義不只在於力量，更是守護。不管未來有多難，我都會在你身邊。」`,
        },
      ],
    ],
    c: [
      [
        {
          text: `當星石的六片記憶碎片成功合一，瞬間散發出耀眼的光芒，照亮了夜空。整個樂園彷彿在回應這股力量，微微震動，星石的光芒穿透了時間的屏障，讓古老的記憶再次甦醒。`,
        },
      ],
      [
        {
          text: `「你看，這就是完整的星石。」
          許墨微笑著將手輕輕覆在你握著星石的手上。`,
        },
      ],
      [
        {
          text: `「或許這段旅程的真實意義，不是星石，而是我們一起經歷的時光。」`,
        },
      ],
      [
        {
          text: `「這趟旅程，讓我更加瞭解你的堅強與溫柔……你呢？是否也能感受到這顆星石的意義？」
          許墨輕輕地將星石舉起，映著溫暖的光芒。`,
        },
      ],
      [
        {
          text: `「我為妳錄下這段影片，希望它能見證我們的回憶。我會在妳需要的每一刻，靜靜守護妳的心。」`,
        },
      ],
    ],
    d: [
      [
        {
          text: `當星石的六片記憶碎片成功合一，瞬間散發出耀眼的光芒，照亮了夜空。整個樂園彷彿在回應這股力量，微微震動，星石的光芒穿透了時間的屏障，讓古老的記憶再次甦醒。`,
        },
      ],
      [
        {
          text: `「我們真的做到了！和薯片小姐一起完成的這一切，感覺比星石還要珍貴。」
          周棋洛興奮地握住你的手，掌心傳來的溫度讓你心跳加速。`,
        },
      ],
      [
        {
          text: `「這顆星石對我來說，不僅是星石的力量，更是我們之間的連結。因為阿薯就是我生命中最特別的存在，它才變得這麼有意義。」`,
        },
      ],
      [
        {
          text: `「和你一起重生星石，比我想像中還要有趣！」
          周棋洛低下頭笑著。`,
        },
      ],
      [
        {
          text: `「我想透過這段影片告訴你，我一直很感激你陪在我身邊。這顆星石的光芒，會永遠照亮我們的回憶。」`,
        },
      ],
    ],
    e: [
      [
        {
          text: `當星石的六片記憶碎片成功合一，瞬間散發出耀眼的光芒，照亮了夜空。整個樂園彷彿在回應這股力量，微微震動，星石的光芒穿透了時間的屏障，讓古老的記憶再次甦醒。`,
        },
      ],
      [
        {
          text: `「還真的成功了。」
          他將星石遞到你面前，指尖輕輕碰觸你的手指。`,
        },
      ],
      [
        {
          text: `「有些人總是能在意想不到的時候，給出驚喜。」
          他故意移開目光，但紅著耳根的模樣洩露了他的真心。`,
        },
      ],
      [
        {
          text: `「這趟旅程還算有點意思。」`,
        },
      ],
      [
        {
          text: `「所以，這段影片算是給你的，別笑我，知道你想要個紀念……才錄的，這顆星石，當它亮起來的時候，就像是我在你身邊一樣。」`,
        },
      ],
    ],
  },
}
